export default __webpack_public_path__ + "static/media/tropicalstudPoker.355fdca9.webp";